import { BODY_TEXT_COLOR } from "../constants";
import { Theme } from "@/routes/innovation-days-demo/types";

interface ThemeContentProps {
  themes: Theme[];
  isExpanded: boolean;
}

export function ThemeContent({ themes, isExpanded }: ThemeContentProps) {
  const visibleThemes = isExpanded ? themes : [themes[0]];
  return (
    <div className="space-y-4">
      {visibleThemes.map((theme, index) => (
        <div
          key={theme.short}
          className="relative"
          style={{ marginTop: index === 0 ? 0 : undefined }}
        >
          {/* Accent bar on the left */}
          <div
            className="absolute left-0 top-0 bottom-0 w-1 rounded-full"
            style={{ background: "#6366F1" }}
          />

          {/* Content container with left padding for accent bar */}
          <div className="pl-4">
            {/* Theme title */}
            <div className="mb-2">
              <h4
                className="text-[16px] leading-[24px] font-semibold"
                style={{ color: BODY_TEXT_COLOR }}
              >
                {theme.short}
              </h4>
            </div>

            {/* Theme description */}
            <div
              className="text-[14px] leading-[20px]"
              style={{ color: "#64748B" }}
            >
              {theme.long}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
